module.exports = {
  default: 'en',
  langs: [
    { key: 'es', locale: 'es-ES' },
    { key: 'en', locale: 'en' },
    { key: 'eu', locale: 'eu' },
  ],
};
